module.exports = __webpack_public_path__ + "static/media/placeholder_logo.da60d4ab.svg";